"use client";
export default function PercentInput({ value, onChange, className }) {
  className = !className ? "rounded  " : className;
  return (
    <div
      className={
        className +
        " hu flex items-center overflow-hidden  bg-dark-50 dark:bg-dark-800/50"
      }
    >
      <input
        type="number"
        className="w-10 flex-1 bg-transparent p-1 pl-2 focus:text-accent-500"
        value={parseInt(value)}
        onChange={(e) => onChange(e.target.value + "%")}
      />
      <div className="pr-2 text-[9px] font-bold opacity-50">%</div>
    </div>
  );
}
